module.exports = ".red-border-class{\n  border: 1px solid red !important;\n}\n\n.hm_block_contact {\n  min-height: 110vh;\n}"